import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import CustomisedSolutions from './images/customized solution icon.png';
import ExperiencedConsultants from './images/Experienced Consultation icon.png';
import HassleFreeProcedure from './images/hustle free icon.png';
import MultiplePaymentOptions from './images/Multiple Payment icon.png';


export default function JAFZA() {

    const posts = [
        {
            title: "Mainland Company Setup",
            desc: "Explore limitless possibilities with Dubai Setup expert guidance in Mainland company formation in Dubai.",
        },
        {
            title: "Offshore Company Setup",
            desc: "Offshore companies can be created and owned by individuals or institutions, and shares can be easily and freely transferred by a written instrument.",
        },
        {
            title: "Free Zone Company Setup",
            desc: "Explore boundless opportunities with A&A Associate LLC’s Freezone company formation in Dubai, UAE !",
        },
    ]



    return (
        <>


            <div className='bg-white'>
                <section className="py-14 " style={{ background: "rgb(242, 249, 255)" }}>
                    <div className="max-w-screen-xl mx-auto px-4 md:text-center md:px-8">
                        <div className="max-w-xl space-y-3 md:mx-auto">
                            <ScrollAnimation animateIn="fadeIn">
                                <h3 className="text-gray-800 text-3xl font-bold sm:text-4xl">
                                    Jebel Ali Free Zone <span style={{ color: "#1fa1cb" }}>(JAFZA) </span>
                                </h3>
                            </ScrollAnimation>
                        </div>
                    </div>
                    <div className="max-w-screen-xl mx-auto px-4  md:px-8 mt-5">
                        <div className="max-w-xxl space-y-3 md:mx-auto">
                            <ScrollAnimation animateIn="fadeIn">
                                <p className="text-gray-600 pb-5">
                                    Jebel Ali Free Zone (JAFZA) is one of the largest and most successful free trade zones in the
                                    world, located in Dubai, United Arab Emirates (UAE). Established in 1985, JAFZA has played a
                                    pivotal role in Dubai's economic growth and transformation into a global business hub. Here's a
                                    description and the benefits of Jebel Ali Free Zone:
                                </p>
                                <p className="text-gray-600 pb-5">
                                    Jebel Ali Free Zone is strategically situated adjacent to the Jebel Ali Port, one of the
                                    largest container ports in the world, and in proximity to Al Maktoum International Airport,
                                    providing easy access to global markets. Spanning over 57 square kilometers, JAFZA offers a
                                    comprehensive ecosystem for businesses across various industries, including manufacturing,
                                    trading, logistics, technology, services, and more. It features world-class infrastructure, modern
                                    facilities, and business-friendly regulations to support the diverse needs of companies operating
                                    within its jurisdiction.
                                </p>
                            </ScrollAnimation>
                            <div className="flex justify-center">
                                <ScrollAnimation animateIn="fadeIn">
                                    <img src="https://dynasty-uae.com/wp-content/uploads/2023/10/pic-10.jpg" className="md:max-w-3xl sm:max-w-xxl sm:rounded-lg" alt="" />
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


            <section className="py-2 mt-5 mb-5" style={{ marginTop: 50 }}>
                <div className="max-w-screen-xl mx-auto px-4">
                    <div className='row' style={{ marginTop: 70 }}>
                        <div className='col '>
                            <div>
                                <ScrollAnimation animateIn="fadeIn">
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 35, marginLeft: 0, lineHeight: 1.2 }}>
                                        JEBEL ALI FREE ZONE  <span style={{ color: "#1fa1cb" }}>(JAFZA)</span>
                                        <br></br>
                                        Benefits:
                                    </h3>
                                </ScrollAnimation>
                            </div>
                        </div>
                        <div className='col '>
                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>1</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Free Zone <span style={{ color: "#1fa1cb" }}>Advantages</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal', }}>
                                            JAFZA offers businesses 100% foreign ownership, full repatriation of
                                            profits and capital, and exemption from corporate and personal income taxes for a specified
                                            period.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>2</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Strategic <span style={{ color: "#1fa1cb" }}>Location</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            Situated in Dubai, JAFZA provides easy access to major transportation hubs,
                                            including Jebel Ali Port and Al Maktoum International Airport, facilitating global trade and
                                            connectivity.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>3</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Global <span style={{ color: "#1fa1cb" }}> Connectivity</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            JAFZA serves as a gateway to regional and international markets, offering
                                            access to over 3.5 billion consumers in the Middle East, Africa, South Asia, and beyond.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>4</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        World-Class <span style={{ color: "#1fa1cb" }}> Infrastructure</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            JAFZA boasts state-of-the-art infrastructure, including industrial
                                            zones, warehouses, office spaces, business parks, logistics facilities, and specialized zones
                                            tailored to different industries.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>5</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Business Support <span style={{ color: "#1fa1cb" }}> Services</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            JAFZA provides a wide range of business support services, including
                                            licensing, registration, visa processing, customs clearance, legal assistance, and administrative
                                            support, to streamline the setup and operation of businesses.

                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>6</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Industry <span style={{ color: "#1fa1cb" }}>Expertise</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            JAFZA has expertise in various industries, including manufacturing, trading,
                                            logistics, technology, automotive, pharmaceuticals, food and beverage, and more, offering
                                            specialized services and support tailored to specific sectors.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>


                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>7</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Logistics <span style={{ color: "#1fa1cb" }}> Hub</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            JAFZA is a major logistics hub, offering integrated logistics solutions, multimodal
                                            transportation options, warehousing facilities, and value-added services to facilitate supply
                                            chain management and distribution.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>8</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Business <span style={{ color: "#1fa1cb" }}>Environment</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            JAFZA provides a favorable business environment with transparent
                                            regulations, investor-friendly policies, and a robust legal framework, ensuring ease of doing
                                            business and investor confidence.

                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>


                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>9</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Networking <span style={{ color: "#1fa1cb" }}>Opportunities</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            Shams organizes events, workshops, seminars, conferences,
                                            and networking sessions to facilitate industry networking, skill development, and
                                            business growth opportunities for its community members.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>


                            <ScrollAnimation animateIn="fadeIn">
                                <div className='flex flex-row'>
                                    <h1 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5" style={{ fontSize: 40, marginLeft: 0 }}>
                                        <span style={{ color: "#1fa1cb" }}>10</span>
                                    </h1>
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-5 " style={{ fontSize: 25, marginLeft: 30 }}>
                                        Sustainability <span style={{ color: "#1fa1cb" }}>Initiatives</span>
                                        <br></br>
                                        <p className="text-gray-600 pb-5" style={{ fontSize: 16, fontWeight: 'normal' }}>
                                            JAFZA is committed to sustainability and environmental stewardship,
                                            implementing green building standards, renewable energy solutions, waste management
                                            programs, and environmental awareness campaigns to minimize its ecological footprint and
                                            promote sustainable development.
                                        </p>
                                    </h3>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>
            </section>




            <div className='bg-white' style={{ paddingTop: 40 }}>
                <section className="py-2 mt-5 mb-5" >
                    <div className="max-w-screen-xl mx-auto px-4">
                        <ScrollAnimation animateIn="fadeIn">
                            <h3 className="text-gray-600 text-2xl font-bold sm:text-3xl pb-1 text-center">
                                Why <span style={{ color: "#1fa1cb" }}>Us?</span>
                            </h3>
                        </ScrollAnimation>
                    </div>
                </section>


                <section className="py-2 mt-5 mb-5 " style={{ marginTop: 30, paddingBottom: 50, display: "flex" }}>
                    <div className="max-w-screen-xl mx-auto px-4">
                        <div className='row whyus-md'> {/* Changed from d-flex justify-content-center to text-center */}
                            <div className='col-md-4 mb-5' style={{ marginRight: '8rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <img
                                        width="55"
                                        height="55"
                                        alt=""
                                        className="attachment-full size-full wp-image-7327 lazyloaded"
                                        decoding="async"
                                        nitro-lazy-empty=""
                                        id="ODUxODoyNzY=-1"
                                        src={CustomisedSolutions} />

                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-1" style={{ fontSize: 24, marginLeft: 15, lineHeight: 1 }}>
                                        Customised <br></br><span style={{ color: "#1fa1cb" }}>Solutions</span>
                                    </h3>
                                </div>
                            </div>
                            <div className='col-md-4 mb-5' style={{ marginRight: '8rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <img
                                        width="55"
                                        height="55"
                                        alt=""
                                        className="attachment-full size-full wp-image-7329 lazyloaded"
                                        decoding="async"
                                        nitro-lazy-empty=""
                                        id="ODUyNjoyNzY=-1"
                                        src={ExperiencedConsultants}
                                    />
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-1" style={{ fontSize: 24, marginLeft: 15, lineHeight: 1 }}>
                                        Experienced <br></br><span style={{ color: "#1fa1cb" }}>Consultants</span>
                                    </h3>
                                </div>
                            </div>
                            <div className='col-md-4 mb-5' style={{ marginRight: '8rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <img width="55" height="55" alt="" class="attachment-full wp-image-7326 lazyloaded" decoding="async" nitro-lazy-empty="" id="ODg3MzoyNzY=-1" src={HassleFreeProcedure} />
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-1" style={{ fontSize: 24, marginLeft: 15, lineHeight: 1 }}>
                                        Hassle-Free <br></br><span style={{ color: "#1fa1cb" }}>Procedure</span>
                                    </h3>
                                </div>
                            </div>
                            <div className='col-md-4 mb-5' >
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <img width="55" height="55" alt="" class="attachment-full wp-image-7328 lazyloaded" decoding="async" id="ODg4MToyNzY=-1" src={MultiplePaymentOptions} />
                                    <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-1" style={{ fontSize: 24, marginLeft: 15, lineHeight: 1 }}>
                                        Multiple Payment <br></br><span style={{ color: "#1fa1cb" }}>Options</span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


            <div className="max-w-screen-xxl mx-auto" style={{ paddingBottom: 40, paddingTop: 40, background: "rgb(242, 249, 255)" }}>
                <section className="py-2 mt-5 ">
                    <div className="max-w-screen-xl mx-auto px-4">
                        <ScrollAnimation animateIn="fadeIn">
                            <h3 className="text-gray-600 text-2xl font-bold sm:text-3xl pb-1 text-center">
                                Our Other <span style={{ color: "#1fa1cb" }}>Services</span>
                            </h3>
                            <p className="text-gray-600 mt-2 text-center font-semibold" style={{ fontSize: 18 }}>
                                Also you can find our Other Services here.
                            </p>
                        </ScrollAnimation>
                    </div>
                </section>

                <div className="max-w-screen-xl mx-auto">
                    <div className=" grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
                        {
                            posts.map((items, key) => (
                                <article className="max-w-md mx-auto mt-4 shadow-lg border  rounded-md duration-300 hover:shadow-sm bg-white our-other-service" key={key} >
                                    <div className='p-5' >
                                        <a href={items.href}>
                                            <div className="pt-3 ml-4 mr-2 mb-3">
                                                <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-1 " style={{ color: "#1fa1cb" }}>
                                                    {items.title}
                                                </h3>
                                                <p className="text-gray-400 text-sm mt-1 " style={{ fontSize: 14 }}>{items.desc}</p>
                                            </div>
                                        </a>
                                    </div>
                                </article>
                            ))
                        }
                    </div>
                </div>
            </div>

        </>
    )
}
